import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Auth } from 'aws-amplify';
import { clearSessionStorage } from 'helpers/clearSessionStorage';

export const authSplitApi = (reducerPath: string, tagTypes?: string[]) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl: import.meta.env.REACT_APP_HOSTNAME_V2,
      prepareHeaders: async (headers) => {
        try {
          const session = await Auth.currentSession();
          headers.set('authorization', `Bearer ${session.getIdToken().getJwtToken()}`);
        } catch (err) {
          clearSessionStorage();
        }
        headers.set('X-Acting-App', 'property_manager');
        return headers;
      },
    }),
    tagTypes: tagTypes || [],
    endpoints: () => ({}),
  });

export const emptySplitApi = (reducerPath: string) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl: import.meta.env.REACT_APP_HOSTNAME_V2,
      prepareHeaders: (headers) => {
        headers.set('X-Acting-App', 'property_manager');
        return headers;
      },
    }),
    endpoints: () => ({}),
  });
